import { TranslationKeys } from '~/common/types';

export const getFilterTranslation = (value: string) => {
  const translations: Record<string, keyof TranslationKeys> = {
    'pmsf': 'app.purchase.search_page.filter.pmsf',
    'electric': 'app.purchase.search_page.filter.specificities.electric',
    'sport': 'app.purchase.search_page.filter.specificities.sport',
    'eco': 'app.purchase.search_page.filter.specificities.eco',
    'standard': 'app.purchase.search_page.filter.other.standard',
    'studded': 'app.purchase.search_page.filter.other.studded',
    'studdable': 'app.purchase.search_page.filter.other.studdable',
    'PREMIUM': 'segment.premium',
    'QUALITY': 'segment.quality',
    'BUDGET': 'segment.budget',
    'total': 'app.purchase.search_page.filter.availabilities.total',
    'partial': 'app.purchase.search_page.filter.availabilities.partial',
    'unavailable': 'app.purchase.search_page.filter.availabilities.unavailable',
    'reinforced': 'app.purchase.search_page.filter.reinforced',
    'sealRunFlat': 'app.common.product.seal_run_flat',
    'campingCar': 'app.purchase.search_page.filter.camping_car',
    'promotion': 'app.purchase.search_page.filter.promotions',
    'CAM': 'vehicle_type.cam',
    '4X4': 'vehicle_type.4x4',
    'TO': 'vehicle_type.to',
  };
  return translations[value] ?? 'app.common.messages.error';
};
